var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "card comments_block" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "card-body" }, [
        _vm.commentsForManager && _vm.commentsForManager.length
          ? _c(
              "div",
              { staticClass: "alert alert-success" },
              [
                _vm._l(_vm.commentsForManager, function (comment) {
                  return _c("div", { staticClass: "border-bottom mb-2" }, [
                    _c("div", {
                      domProps: { innerHTML: _vm._s(comment.text) },
                    }),
                    _vm._v(" "),
                    _c("p", { staticClass: "text-muted text-right" }, [
                      _vm._v(
                        _vm._s(comment.user_name) +
                          " " +
                          _vm._s(
                            _vm.printDate(
                              comment.created_at,
                              "DD.MM.YYYY HH:mm",
                              false,
                              -1
                            )
                          )
                      ),
                    ]),
                  ])
                }),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" }),
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "form",
          {
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return _vm.saveComment()
              },
            },
          },
          [
            _c("div", { staticClass: "input-group mb-3 mt-2" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.newManagerComment,
                    expression: "newManagerComment",
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "text", placeholder: "Комментарий к заявке" },
                domProps: { value: _vm.newManagerComment },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.newManagerComment = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("LoadingButton", {
                    attrs: {
                      type: "submit",
                      title: "Сохранить комментарий",
                      className: "btn btn-outline-success form-field",
                      color: "#4fc47f",
                      loading: _vm.saveCommentLoading,
                      onClick: () => {},
                    },
                  }),
                ],
                1
              ),
            ]),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card comments_block" }, [
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "card-body" }, [
        _vm.commentsForRunner && _vm.commentsForRunner.length
          ? _c(
              "div",
              { staticClass: "alert alert-info" },
              _vm._l(_vm.commentsForRunner, function (comment) {
                return _c("div", [
                  _c(
                    "p",
                    [
                      comment && +comment.comment_type === 2
                        ? [_c("i", { staticClass: "icon-fa icon-fa-dropbox" })]
                        : [
                            _c("i", {
                              staticClass: "icon-fa icon-fa-motorcycle",
                            }),
                          ],
                      _vm._v(
                        "\n            " + _vm._s(comment.text) + "\n          "
                      ),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("p", { staticClass: "text-muted text-right" }, [
                    _vm._v(
                      _vm._s(comment.user_name) +
                        " " +
                        _vm._s(comment.created_at)
                    ),
                  ]),
                ])
              }),
              0
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "form",
          {
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return _vm.saveComment("runner")
              },
            },
          },
          [
            _c("div", { staticClass: "input-group mb-3 mt-2" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.newRunnerComment,
                    expression: "newRunnerComment",
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "text", placeholder: "Комментарий курьерам" },
                domProps: { value: _vm.newRunnerComment },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.newRunnerComment = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("LoadingButton", {
                    attrs: {
                      title: "Сохранить комментарий",
                      type: "submit",
                      color: "#4fc47f",
                      className: "btn btn-outline-success form-field",
                      loading: _vm.saveCommentLoading,
                      onClick: () => {},
                    },
                  }),
                ],
                1
              ),
            ]),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h6", [_vm._v("Комментарии для менеджеров")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h6", [_vm._v("Комментарии для курьеров")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }